module.exports = __webpack_public_path__ + "static/media/face-agent-contact.d5137634.svg";